import React from 'react'

const EnrolledLearners = () => {
  return (
    <div>EnrolledLearners</div>
  )
}

export default EnrolledLearners